import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDetailsSubheader',
  setup(__props) {

const { colors } = useColors();

return { __sfc: true,colors, RmpText }
}

})